import { render, staticRenderFns } from "./DocumentPortalItem.vue?vue&type=template&id=28e4f1da&scoped=true&"
import script from "./DocumentPortalItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalItem.vue?vue&type=style&index=0&id=28e4f1da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4f1da",
  null
  
)

export default component.exports